import PhoneImage from '../assets/phone-img.png';
import PhoneImageMedium from '../assets/phone-img-med.png';
import AccessLearnConnect from '../assets/access-learn-connect.png';
import AccessLearnConnectMedium from '../assets/access-learn-connect-medium.png';

function SectionTwo() {
  return (
    <section
      className="bg-gold text-white flex flex-col md:flex-row justify-center bg-center bg-about-section-rings bg-no-repeat md:bg-about-section-rings-medium md:bg-p-about-section"
      id="about"
    >
      <div className="px-8 md:py-7 max-h-80 md:max-h-72 lg:max-h-96">
        <picture>
          <source
            srcSet={AccessLearnConnectMedium}
            media="(min-width: 768px)"
          />
          <img src={AccessLearnConnect} alt="" className="max-h-full h-full" />
        </picture>
      </div>
      <div className="max-h-96 md:max-h-72 lg:max-h-[490px] xl:max-h-[560px] 3xl:max-h-[600px] overflow-hidden justify-end items-start flex md:flex-1">
        <picture>
          <source media="(min-width: 768px)" srcSet={PhoneImageMedium} />
          <img src={PhoneImage} alt="" className="max-h-full h-full" />
        </picture>
      </div>
    </section>
  );
}

export default SectionTwo;
